export type Moneda = 'COP' | 'USD' | 'DOP';
export const MONEDAS: Moneda[] = ['COP', 'USD', 'DOP'];
export const SIMBOLO: Record<Moneda, string> = { COP: '$', USD: 'US$', DOP: 'RD$' };
export const NOMBRE_MONEDA: Record<Moneda, string> = { COP: 'Pesos colombianos', USD: 'Dólares', DOP: 'Pesos dominicanos' };
export const nf = (n: number, d = 0) => (+n || 0).toLocaleString('es-CO', { maximumFractionDigits: d });
// $ 165.000 · US$ 56 · US$ 12,50 (decimales solo en dólares y solo si los hay).
export function money(n: number, mon: Moneda = 'COP'): string {
  const v = +n || 0, r = Math.round(v * 100) / 100, dec = mon === 'USD' && !Number.isInteger(r) ? 2 : 0;
  return (v < 0 ? '−' : '') + SIMBOLO[mon] + ' ' + Math.abs(v).toLocaleString('es-CO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
}
export const pct = (x: number) => (isFinite(x) ? Math.round(x * 100) + '%' : '—');
